import { useEffect } from 'react';
import { useAppDispatch } from 'app/store';
import { setHeaderTitle, setHeaderAction, setActionBtnTitle } from 'features/ui/model/uiSlice';
import { CompetitionsDetail } from 'widgets/competitions-b2b/detail/CompetitionDetail';

export const CompetitionB2BDetailPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle('Соревнование'));
    dispatch(setHeaderAction('edit'));
    dispatch(setActionBtnTitle('Редактировать'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, []);

  return <CompetitionsDetail />;
};
